<!--
 * @Author: your name
 * @Date: 2021-09-03 13:39:48
 * @LastEditTime: 2021-09-22 14:29:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/components/discountZone.vue
-->
<!--  -->
<template>
  <div class="discount" v-if="isShowDiscount">
    <!--  优惠券  -->
    <div class="priceModule-installment">
      <h3 class="installment-title" v-if="showPreferentialTitle">优惠</h3>
      <div class="discount-box">
        <div
          v-for="(item, index) in fullReductionData"
          :key="`full${index}`"
          class="discount-hb"
        >
          <div class="discount-hb-left">
            <TagComponent class="full-discount-tag" text="满减" />
            <span class="installment-content">{{ fullReductionTypeToText(item) }}</span>
          </div>
        </div>
        <!-- 增加买赠活动赠品（优惠券） -->
        <div v-if="giftCouponRespList && !giftMaterialList && !giftMemberList && !buyStatus" class="discount-hb"
          @click="giveGiftsList">
          <div class="discount-hb-left">
            <TagComponent text="赠品" />
            <span v-for="(item, index) in giftCouponRespList.slice(0, 1)" :key="index" class="taxPreference">{{
              item.discountType === 1 ? `满` + item.usableCondition + `减` + item.discountAmount :
                `满` + item.usableCondition + `打` + item.discountAmount +`折`}}</span>
          </div>
          <img src="../../../assets/img/productDetail/icon_right.png" class="right-icon" alt />
        </div>

        <!-- 增加赠品(买课赠实物活动) -->
        <div v-if="giftMaterialList && !giftMemberList && !buyStatus" class="discount-hb" @click="giveGiftsList">
          <div class="discount-hb-left">
            <TagComponent text="赠品" />
            <span class="taxPreference addEllips">{{ giftMaterialList[0].materialName }}</span>
          </div>
          <img src="../../../assets/img/productDetail/icon_right.png" class="right-icon" alt />
        </div>

        <div v-if="giftMemberList && !buyStatus" class="discount-hb" @click="giveGiftsList">
          <div class="discount-hb-left">
            <TagComponent text="赠品" />
            <span class="taxPreference addEllips">{{ giftMemberList[0].name }}</span>
          </div>
          <img src="../../../assets/img/productDetail/icon_right.png" class="right-icon" alt />
        </div>
      </div>
    </div>
    <!-- <div class="couponBoxCenter" @click="openCouponAcvitity" v-if="couponDetail.couponId">
      <div class="couponDisType">
        <div
          class="discountAmount"
        >{{ couponDetail.discountAmount }}{{ couponDetail.discountType === 1 ? `元` : `折` }}</div>
        <div>
          <p
            class="usableCondition"
            v-if="couponDetail.discountType === 1"
          >满{{ couponDetail.usableCondition }}减{{ couponDetail.discountAmount }}</p>
          <p
            class="usableCondition"
            v-else
          >满{{ couponDetail.usableCondition }}打{{ couponDetail.discountAmount }}折</p>
          <p class="timeCount" v-if="showTime">限时抢券：{{showTime}}</p>
        </div>
      </div>
      <div class="openCouList">立即领取</div>
    </div> -->

    <div class="coupon_box" @click="openCouponAcvitity" v-if="couponDetail.couponId">
      <img class="coupon_time_icon" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_new_icon.png"
        alt v-if="showTime" />
      <div class="coupon_left">
        <div class="coupon_left_box1" v-if="couponDetail.discountType == 2">
          <div class="left_num1">{{ couponDetail.discountAmount }}</div>
          <div class="left_num2">折</div>
        </div>
        <div class="coupon_left_box2" v-if="couponDetail.discountType == 1">
          <div class="left_num1">{{ couponDetail.discountAmount }}</div>
          <div class="left_num2">元</div>
        </div>
      </div>
      <div class="coupon_right">
        <p class="right_text" v-if="couponDetail.discountType === 1">满{{ couponDetail.usableCondition }}减{{
          couponDetail.discountAmount }}</p>
        <p class="right_text" v-else>满{{ couponDetail.usableCondition }}打{{ couponDetail.discountAmount }}折</p>
        <p class="right_text2" v-if="showTime">限时抢券：{{ showTime }}</p>
      </div>
    </div>
    <!-- 优惠券列表 -->
    <CouponList ref="couponList" />
    <!-- 赠品优惠券列表 作废 -->
    <!-- <GiveCouponPop
      v-if="GiveCouponShow"
      @giveCouponClose="giveCouponClose"
      :wholeGiftlist="giftCouponRespList"
    />-->
    <!-- 赠品实物列表 作废-->
    <!-- <GiveGiftsPop
      v-if="GiveGiftsShow"
      @giveGiftsClose="giveGiftsClose"
      :giftMaterialList="giftMaterialList"
    />-->

    <!-- 新-赠品弹窗列表,包含会员、实物、券 -->
    <GiveGiftsAll :wholeGiftlist="giftCouponRespList" :giftMaterialList="giftMaterialList"
      :giftMemberList="giftMemberList" v-if="GiveGiftsShow" @giveGiftsClose="giveGiftsClose" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
// import { reqReceiveCoupon } from '@/api/coupon/index';
// eslint-disable-next-line import/extensions
import TagComponent from '@/components/commonComponents/TagComponent';
// import GiveCouponPop from '@/components/courseDetail/giveCouponPop.vue';
// import GiveGiftsPop from '@/components/courseDetail/giveGiftsPop.vue';
import { replaceHyphens, timerYhqCount } from '@/utils/tools';
import GiveGiftsAll from '@/components/courseDetail/giveGiftsAll.vue';
import CouponList from './couponList.vue';
import { miniSchemeUrl } from '@/utils/common.js';

export default {
  components: {
    CouponList,
    TagComponent,
    // GiveCouponPop,
    // GiveGiftsPop,
    GiveGiftsAll,
  },
  props: {
    giftCouponRespList: {
      type: Array,
      default: () => { },
    },
    giftMaterialList: {
      type: Array,
      default: () => { },
    },
    giftMemberList: {
      type: Array,
      default: () => { },
    },
    buyStatus: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      couponDetail: {},
      GiveCouponShow: false, // 赠券弹窗
      GiveGiftsShow: false, // 赠品弹窗
      timers: null,
      showTime: '', // 倒计时
    };
  },
  computed: {
    ...mapState(['courseBaseData', 'allAcvitity']),
    fullReductionData() {
      return this.allAcvitity.packageDetailFullPromotionRespList || [];
    },
    showPreferentialTitle() {
      const hasFullPromotion = this.fullReductionData.length;
      const hasGift = (this.giftCouponRespList || this.giftMaterialList || this.giftMemberList) && !this.buyStatus;
      return hasFullPromotion || hasGift;
    },
    // 是否展示优惠信息
    isShowDiscount() {
      // const {
      //   status,
      //   isValid,
      //   validPeriodType,
      //   isSetStock,
      //   availableStock,
      //   isRepeatBuy,
      //   productId,
      // } = this.courseBaseData;
      // // 未上架 || 已过期 || 已售罄 || 已下架 || 已购买且不可重复购买
      // if (
      //   status <= 3 ||
      //   (!isValid && validPeriodType !== 1 && productId) ||
      //   (isSetStock === 1 && availableStock <= 0) ||
      //   status === 6 ||
      //   (this.buyStatus.length && isRepeatBuy === 0)
      // ) {
      //   return false;
      // }
      let flag = false;
      if (this.couponDetail.couponId) {
        // 优惠卷
        flag = true;
      } else if (this.giftCouponRespList) {
        // 是否带赠送的优惠券
        flag = true;
      } else if (this.giftMaterialList) {
        // 是否带赠送的实物
        flag = true;
      } else if (this.giftMemberList) {
        flag = true;
      } else if (this.fullReductionData.length) {
        flag = true;
      }

      return flag;
    },
  },
  watch: {
    allAcvitity(data) {
      if (data.packageDetailCouponPromotionResp) {
        const idx = 0;
        this.couponDetail = data.packageDetailCouponPromotionResp.couponChooseRespList[idx];
        this.countTime();
      }
    },
  },
  methods: {
    fullReductionTypeToText(item) {
      const type = item.fullDiscountType;
      const list = item.fullDiscountConditionList || [];
      if (!list.length) {
        return '';
      }
      if (type === 1) {
        return list
          .map((condition) => `满${condition.fullAmount}减${condition.discountAmount}`)
          .join('，');
      }
      const first = list[0];
      if (type === 2) {
        return `每满${first.fullAmount}减${first.discountAmount}`;
      }
      if (type === 3) {
        return `满${first.fullAmount}打${first.discountRate}折`;
      }
      return '';
    },
    async openCouponAcvitity() {
      if (this.$root.$data.zxMini) {
        const path = '/subPackages/detailWebView/index';
        const url = window.location.href
        const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
        wx.miniProgram.navigateTo({
          url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
        });
        return;
      }
      const { couponChooseRespList } = this.allAcvitity.packageDetailCouponPromotionResp;
      // 当只有一个优惠券时，直接领取
      if (couponChooseRespList.length === 1) {
        if (couponChooseRespList[0].hasGetAlready === 0) {
          const couponItem = couponChooseRespList[0];
          this.$refs.couponList.receiveCoupon(couponItem, 0);
        } else {
          this.$toast('已领取');
        }
      } else {
        this.$refs.couponList.show = true;
      }
    },
    giveCouponList() {
      if (this.$root.$data.zxMini) {
        const path = '/subPackages/detailWebView/index';
        const url = window.location.href
        const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
        wx.miniProgram.navigateTo({
          url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
        });
        return;
      }
      this.GiveCouponShow = true;
    },
    giveCouponClose() {
      this.GiveCouponShow = false;
    },
    async giveGiftsList() {
      if (this.$root.$data.zxMini) {
        const path = '/subPackages/detailWebView/index';
        const url = window.location.href
        const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
        wx.miniProgram.navigateTo({
          url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
        });
        return;
      }
      this.GiveGiftsShow = true;
    },
    giveGiftsClose() {
      this.GiveGiftsShow = false;
    },
    // 倒计时
    countTime() {
      const { receiveTimeEnd } = this.couponDetail;
      // 当前时间戳
      const now = new Date().getTime();
      // 结束时间戳
      const end = new Date(replaceHyphens(receiveTimeEnd)).getTime();
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.showTime = null;
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      let temp = end - now + 1000;
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.showTime = timerYhqCount(temp);
        } else {
          console.log(temp);
          this.showTime = null;
          clearInterval(this.timers);
        }
      }, 1000);
    },
  },
  created() { },
  mounted() { },
  destroyed() {
    clearInterval(this.timers);
  },
};
</script>

<style lang="scss" scoped>
.coupon_box {
  position: relative;
  display: flex;
  height: 156px;

  .coupon_time_icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 105px;
    height: 43px;
  }

  .coupon_left {
    width: 185px;
    height: 156px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_new_left.png') no-repeat;
    background-size: cover;

    .coupon_left_box1 {
      display: flex;
      justify-content: center;
      width: 171px;
      height: 156px;

      .left_num1 {
        height: 80px;
        margin-top: 45px;
        color: #fff;
        font-weight: normal;
        font-size: 72px;
        font-family: Arial, sans-serif;
        line-height: 80px;
      }

      .left_num2 {
        height: 36px;
        margin-top: 76px;
        color: #fff;
        font-weight: 600;
        font-size: 25px;
        font-family: 'PingFang SC', sans-serif;
        line-height: 36px;
      }
    }

    .coupon_left_box2 {
      display: flex;
      justify-content: center;
      width: 171px;
      height: 156px;

      .left_num1 {
        height: 56px;
        margin-top: 60px;
        color: #fff;
        font-weight: normal;
        font-size: 51px;
        font-family: Arial, sans-serif;
        line-height: 56px;
      }

      .left_num2 {
        height: 36px;
        margin-top: 73px;
        color: #fff;
        font-weight: 600;
        font-size: 25px;
        font-family: 'PingFang SC', sans-serif;
        line-height: 36px;
      }
    }
  }

  .coupon_right {
    display: flex;
    flex-direction: column;
    gap: 11px;
    justify-content: center;
    width: 493px;
    height: 156px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_new_right.png') no-repeat;
    background-size: cover;

    .right_text {
      display: block;
      height: 33px;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      font-family: 'PingFang SC', sans-serif;
      line-height: 33px;
    }

    .right_text2 {
      height: 29px;
      color: #fff;
      font-weight: 400;
      font-size: 22px;
      font-family: 'PingFang SC', sans-serif;
      line-height: 29px;
    }
  }
}

.discount {
  width: 100%;
  padding: 0 36px 26px 36px;
  background: #fff;
  border-radius: 0 0 14px 14px;

  .priceModule-installment {
    display: flex;
    align-items: flex-start;
    padding-bottom: 16px;

    .installment-title {
      margin-top: 10px;
      margin-right: 19px;
      // padding-top: 16px;
      color: #333;
      font-weight: 600;
      font-size: 25px;
      line-height: 43px;
    }

    .discount-box {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;

      .discount-hb {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 10px;
        // margin-bottom: 20px;
        padding-bottom: 2px;
        padding-left: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        .discount-hb-left {
          display: flex;
          align-items: stretch;
          justify-content: space-between;

          ::v-deep .full-discount-tag.tag-component {
            flex-shrink: 0;
            align-self: flex-start;
            box-sizing: border-box;
            width: auto;
            min-width: 0;
            height: 40px;
            padding: 2px 8px 0;
            color: rgba(255, 108, 2, 1);
            font-weight: normal;
            font-size: 24px;
            font-family: PingFangSC-Regular, 'PingFang SC', sans-serif;
            line-height: 34px;
            white-space: nowrap;
            text-align: justify;
            background-color: rgba(255, 126, 32, 0.15);
            border: 2px solid rgba(255, 108, 2, 1);
            border-radius: 4px;
          }

          .taxPreference,
          .installment-content {
            margin-left: 22px;
            color: #333;
            font-weight: 400;
            font-size: 25px;
            line-height: 36px;
          }

          .addEllips {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }

        .right-icon {
          width: 43px;
        }

        .open {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            // padding-top: 8px;
            color: #fa8947;
            font-size: 25px;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .couponBoxCenter {
    display: flex;
    align-items: center;
    width: 678px;
    height: 91px;
    margin: 0 auto;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/courseDetail/couponNewBg.png') no-repeat center;
    background-size: 100% 100%;

    .couponDisType {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 82%;

      .discountAmount {
        width: 111px;
        color: #fff;
        font-weight: 600;
        font-size: 29px;
        text-align: center;
      }

      .usableCondition {
        margin-bottom: 12px;
        padding-left: 18px;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
      }

      .timeCount {
        padding-left: 18px;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
      }
    }

    .openCouList {
      width: 18%;
      height: 40px;
      margin-right: 22px;
      color: #fff;
      font-weight: 500;
      font-size: 18px;
      line-height: 40px;
      text-align: center;
      background: #fd6a81;
      border-radius: 20px;
    }
  }
}

::v-deep .van-icon-arrow {
  color: #787878;
  font-size: 19px;
}
</style>
